<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Ручное квитирование</h3>
            </v-flex>
            <v-flex xs12>
                <v-card>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
<!--                                    {{card}}-->
                                    <v-checkbox
                                            v-model="PaymentNotLoaded"
                                            label="Квитировать начисление без уплат"
                                            :disabled="this.card.status!=1 || this.card.annulment != null"
                                    ></v-checkbox>
                                </v-flex>
                                <v-flex xs11>
                                    <v-text-field
                                            v-model.trim="card.paymentId"
                                            label="УИП"
                                            :disabled="this.PaymentNotLoaded || this.card.status!=1 || this.card.annulment != null"
                                            :append-outer-icon="'mdi-select-search'"
                                            @click:append-outer="$router.push({name: 'gis_gmp_export_payment', params: {'charge_id': $route.params.charge_id, 'forcedAcknowledgement_id': $route.params.id}})"
                                    ></v-text-field>
                                    <v-btn
                                            @click.native="$router.push({name: 'gis_gmp_forced_acknowledgement_receipt', params: {'forcedAcknowledgement_id': $route.params.id}})"
                                            v-show="this.card.export_payment_html!==''"
                                    >Квитанция об уплате</v-btn>
                                </v-flex>
                                <v-flex xs12>
                                    <div>
                                        <v-progress-linear
                                                indeterminate
                                                color="primary"
                                                v-if="listLoading.includes('gis_gmpFetchForcedAcknowledgement')"
                                        ></v-progress-linear>
                                        <p><strong>Тип запроса:</strong> {{card.kind}} </p>
                                        <p><strong>Состояние:</strong> {{ getChargeCondition(card.status).condition }}</p>
                                        <p
                                                v-if="card.billStatus!==null"
                                        ><strong>Статус квитирования с платежами:</strong> {{ getAcknowledgmentStatus(card.billStatus).name }}</p>
                                        <v-btn
                                                @click.native="$router.push({name: 'gis_gmp_forced_acknowledgement_dispatch_report', params: {'forcedAcknowledgement_id': $route.params.id}})"
                                                v-show="this.card.response_data_html!==''"
                                        >Отчет об отправке</v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click.native="close"
                    >Отмена</v-btn>
                    <v-btn
                            @click.native="save(1)"
                            v-show="([1, 2].includes(this.card.status))"
                    >Сохранить как черновик</v-btn>
                    <v-btn
                            @click.native="save(2)"
                            v-show="[1].includes(this.card.status)"
                    >Сохранить и разрешить отправку</v-btn>
                    <v-btn
                            @click.native="deleteCard()"
                            v-show="[1].includes(this.card.status)"
                    >Удалить</v-btn>
                    <v-btn
                            @click.native="annulment()"
                            v-show="[4].includes(this.card.status) && this.card.billStatus!==null && [4, 5].includes(this.card.billStatus)"
                    >Создать запрос на отмену принудительного квитирования</v-btn>
                </v-card-actions>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'cardForcedAcknowledgement',
  data () {
    return {
      t: 1
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    card () {
      return this.$store.getters['gis_gmpForcedAcknowledgement/card']
    },
    PaymentNotLoaded: {
      get () {
        return this.$store.getters['gis_gmpForcedAcknowledgement/card'].PaymentNotLoaded
      },
      set (value) {
        this.$store.commit('gis_gmpForcedAcknowledgement/setCardPaymentNotLoaded', value)
      }
    },
    // billStatus () {
    //   if ('active_sending' in this.card && this.card.active_sending !== null && 'billStatus' in this.card.active_sending) {
    //     return this.card.active_sending.billStatus
    //   }
    //   return null
    // },
    listDetail () {
      return this.$store.getters['gis_gmpForcedAcknowledgement/listForcedAcknowledgementDetail']
    }
  },
  methods: {
    initialize () {
      this.$store.dispatch('gis_gmpForcedAcknowledgement/fetchForcedAcknowledgementCard', {
        id: this.$route.params.id })
    },
    save (status) {
      this.$store.dispatch('gis_gmpForcedAcknowledgement/insertForcedAcknowledgementCard',
        {
          id: this.card.id,
          charge: this.card.charge,
          status: status,
          PaymentNotLoaded: this.card.PaymentNotLoaded,
          paymentId: this.card.paymentId })
        .then(() => {
          this.close()
        })
    },
    close () {
      this.$router.go(-1)
    },
    annulment (status) {
      this.$store.dispatch('gis_gmpForcedAcknowledgement/annulmentForcedAcknowledgementCard', this.card.id)
    },
    getChargeCondition (conditionId) {
      return this.$store.getters['gis_gmpCharge/getChargeCondition'](conditionId)
    },
    deleteCard (id) {
      this.$store.dispatch('gis_gmpForcedAcknowledgement/deleteForcedAcknowledgementCard', this.card.id)
        .then(() => {
          this.$router.go(-1)
        })
    },
    getAcknowledgmentStatus (id) {
      return this.$store.getters['gis_gmpCharge/getAcknowledgmentStatus'](id)
    }
  },
  created: function () {
    if (this.card.id === null) {
      this.initialize()
    }
  }
}
</script>
<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }
    th {
        vertical-align: top
    }
    .bloc_inline
    {
        display:inline-block;
    }
    .bloc
    {
        border: 1px solid gray
    }
</style>
